/** @format */

import React, { Fragment, useEffect, useState, useRef } from "react";
import TableForm from "./tableForm";
import ReactToPrint from "react-to-print";
import { useReactToPrint } from "react-to-print";
import { ToastContainer, toast } from "react-toastify";
import "../App.css";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  Link,
} from "react-router-dom";

import { Document, Page, pdfjs } from "react-pdf";

import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import "primereact/resources/themes/lara-light-indigo/theme.css"; //theme
import "primereact/resources/primereact.min.css"; //core css
import "primeicons/primeicons.css";
import logo from "./logo/udes.png";
import { tr } from "date-fns/locale";
import { set } from "date-fns";

export const VisistReqTreatment = ({ setAuth }) => {
  const [reqUpdateData, setReqUpdateData] = useState({
    intern_req_asigned_str: "",
    intern_id: "",
  });

  const [name, setName] = useState("");
  const [priv, setPriv] = useState("");

  async function getName() {
    try {
      const resp = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/dashboard`,
        {
          method: "GET",
          headers: { token: localStorage.token },
        }
      );
      const parsRes = await resp.json();
      // console.log(parsRes);

      setName(parsRes.emp_name);
      setPriv(parsRes.emp_level);
    } catch (err) {
      console.error(err.message);
    }
  }

  const [structures, setStructures] = useState([]);

  async function getStructures() {
    try {
      const getStr = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/structures`
      );
      const parsRes = await getStr.json();
      setStructures(parsRes);
    } catch (err) {
      console.error(err.message);
    }
  }

  // get all apprenticeship requests -------------------

  const [visitRequests, setVisitRequests] = useState([]);

  async function getVisitRequests() {
    try {
      const resp = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/visitRequests`,
        {
          method: "GET",
          headers: { token: localStorage.token },
        }
      );
      const parsRes = await resp.json();
      // console.log(parsRes);
      setVisitRequests(parsRes);
    } catch (err) {
      console.error(err.message);
    }
  }

  //   const [selectedReqDocs, setSelectedReqDocs] = useState([]);
  //   const getSelectedReqDocs = (docsList, reqId) => {
  //     let element = [];
  //     if (reqId !== null && reqId !== undefined) {
  //       element = docsList.filter((doc) =>
  //         doc.split("-")[0].endsWith(reqId.toString())
  //       );
  //     }

  //     setSelectedReqDocs(element);
  //   };

  //   const [selectedReqProfilePic, setSelectedReqProfilePic] = useState([]);
  //   const getSelectedReqProfilePic = (docsList, reqId) => {
  //     setSelectedReqProfilePic([]);
  //     let element = [];
  //     if (reqId !== null && reqId !== undefined) {
  //       element = docsList.filter((doc) =>
  //         doc.split("-")[0].endsWith(reqId.toString())
  //       );
  //     }

  //     setSelectedReqProfilePic(element);
  //   };

  //----------------------------------------------------

  // update the status of the request ----------------------------------

  //   async function updateInternShipReqStatus() {
  //     try {
  //       const reqStatusUpdate = await fetch(
  //         `${process.env.REACT_APP_BACKEND_URL}/api/updateInternShipReqStatus`,
  //         {
  //           method: "POST",
  //           headers: {
  //             "Content-type": "application/json",
  //             token: localStorage.token,
  //           },
  //           body: JSON.stringify(reqUpdateData),
  //         }
  //       );

  //       if (reqStatusUpdate.ok) {
  //         accept();
  //         document.getElementById("request-dispatching-btn").disabled = true;
  //         document.getElementById("printing-menu-btn").disabled = true;
  //         getVisitRequests();
  //       }
  //     } catch (err) {
  //       console.error(err.message);
  //     }
  //   }

  // --------------------------------------------------------------------

  const [selectedReqID, setSelectedReqID] = useState(null);

  const handleRequestSelect = (reqID) => {
    setSelectedReqID(reqID);
  };

  const [selectedForm, setSelectedForm] = useState([]);
  const getReqToDisplay = (selectedId) => {
    for (let i = 0; i < visitRequests.length; i++) {
      if (visitRequests[i].visit_id === selectedId) {
        setSelectedForm(visitRequests[i]);
      }
    }

    // if (selectedStructure !== 0) {
    //   document.getElementById("request-dispatching-btn").disabled = false;
    // }
  };

  //   const [selectedStructure, setSelectedStructure] = useState(null);
  //   const selectStructure = (e) => {
  //     setSelectedStructure(e.target.value);
  //     if (selectedForm.length !== 0) {
  //       document.getElementById("request-dispatching-btn").disabled = false;
  //     }
  //   };

  //   const handleReqAsign = () => {
  //     reqUpdateData.intern_req_asigned_str = selectedStructure;
  //     reqUpdateData.intern_id = selectedForm.intern_id;
  //     updateInternShipReqStatus();
  //     setSelectedReqID(null);
  //     setSelectedForm([]);
  //     setSelectedStructure("");
  //   };

  //   const getStrName = (strId) => {
  //     for (let i = 0; i < structures.length; i++) {
  //       if (strId === null) {
  //         return "None affecté";
  //       } else if (structures[i].str_id === strId) {
  //         return structures[i].str_name;
  //       }
  //     }
  //   };

  useEffect(() => {
    document.getElementById("printing-menu-btn").disabled = false;
    document.getElementById("btn-delete-app-req").disabled = false;

    // if (selectedStructure === NaN) {
    //   document.getElementById("request-dispatching-btn").disabled = false;
    // }
  }, [selectedForm]);

  useEffect(() => {
    getReqToDisplay(selectedReqID);
    // getSelectedReqDocs(attachedFilesPaths, selectedReqID);
    // getSelectedReqProfilePic(attachedProfilePicPaths, selectedReqID);
  }, [selectedReqID]);

  useEffect(() => {
    // getStructures();
    getVisitRequests();
    // document.getElementById("request-dispatching-btn").disabled = true;
    document.getElementById("printing-menu-btn").disabled = true;
    document.getElementById("btn-delete-app-req").disabled = true;
  }, []);

  const logout = (e) => {
    e.preventDefault();
    localStorage.removeItem("token");
    setAuth(false);
    toast.current.show({
      severity: "success",
      summary: "Session",
      detail: "Deconnecté",
    });
  };

  useEffect(() => {
    getName();
  });

  const toast = useRef(null);

  const accept = () => {
    toast.current.show({
      severity: "success",
      summary: "conifrmé",
      detail: "demande affectée",
      life: 3000,
    });
  };

  const reject = () => {
    toast.current.show({
      severity: "warn",
      summary: "Annulée",
      detail: "demande annulée",
      life: 3000,
    });
  };

  //   const confirm1 = (e) => {
  //     e.preventDefault();
  //     confirmDialog({
  //       message: "Confirmer l'affectation de la demande?",
  //       header: "Confirmation",
  //       icon: "pi pi-exclamation-triangle",
  //       acceptLabel: "Oui",
  //       rejectLabel: "Non",
  //       accept: () => handleReqAsign(),
  //       reject,
  //     });
  //   };

  console.log(selectedReqID);

  // print the document -------------------------------------------------

  // Create a refs array
  const componentRefs = useRef([]);

  const componentRef = React.useRef(null);

  const reactToPrintContent = React.useCallback(() => {
    return componentRef.current;
  }, [componentRef.current]);

  const componentRef2 = React.useRef(null);

  const reactToPrintContent2 = React.useCallback(() => {
    return componentRef2.current;
  }, [componentRef2.current]);

  const reactToPrintTrigger = React.useCallback(() => {
    return (
      <button
        className="bg-custom_blue1 hover:bg-blue-700"
        id="printing-menu-btn"
      >
        Imprimer
      </button>
    );
  }, []);

  //---------------------------------------------------------------------------------

  const handleAppRequestDelete = async () => {
    try {
      if (
        selectedReqID !== "" ||
        selectedReqID !== null ||
        selectedReqID !== undefined
      ) {
        const userDelete = await fetch(
          `${process.env.REACT_APP_BACKEND_URL}/api/VisitRequestDelete/${selectedReqID}`,
          {
            method: "DELETE",
            headers: { token: localStorage.token },
          }
        );
        if (userDelete.status === 200) {
          toast.current.show({
            severity: "success",
            summary: "conifrmé",
            detail: "Demande supprimé",
            life: 3000,
          });
          getVisitRequests();
          document.getElementById("btn-delete-app-req").disabled = true;
        }
      }
      // const parsRes = await userDelete.json();
    } catch (err) {
      console.error(err.message);
    }
  };

  const confirm2 = (e) => {
    e.preventDefault();
    confirmDialog({
      message: "Confirmer la suppression de la demande de visite?",
      header: "Confirmation",
      icon: "pi pi-exclamation-triangle",
      acceptLabel: "Oui",
      rejectLabel: "Non",
      accept: () => handleAppRequestDelete(),
      reject,
      className: "my-custom-confirm-dialog",
    });
  };

  return (
    <Fragment>
      <div id="navbar" className="topnav">
        <div className="left-menu-4">
          <Link to="/dashboard">Accueil</Link>
        </div>
        <div className="right-menu">
          <button className="dash-logout" onClick={(e) => logout(e)}>
            Se déconnecter
          </button>

          <div className=" relative flex items-center justify-center float-right pr-3">
            <span className="p-3 text-white">{name}</span>
          </div>
        </div>
      </div>

      <div className="training-req-container">
        <div className="req_treatment_container-fluid">
          <div className="req_treatment_list">
            <table className="table-list">
              <thead className="table-header">
                <tr>
                  <th>Nom du demandeur</th>

                  <th>Date de la demande</th>
                </tr>
              </thead>
              <tbody>
                {visitRequests.map((request) => (
                  <tr
                    onClick={(e) => handleRequestSelect(request.visit_id)}
                    className="table-row"
                    key={request.visit_id}
                  >
                    <td>{request.visit_name}</td>
                    <td>
                      {new Date(request.visit_start_date).toLocaleDateString(
                        "en-GB"
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="req-tr-document">
            <div ref={componentRef} className="document-page">
              <div className="doc-heading">
                <div className="doc-heading-top">
                  <div className="doc-ht-ar">
                    الجمهورية الجزائرية الديمقراطية الشعبية
                  </div>
                  <div className="doc-ht-fr">
                    République Algérienne Démocratique et Populaire
                  </div>
                  <div className="doc-ht-ar">
                    وزارة التعليم العالي و البحث العلمي
                  </div>
                  <div className="doc-ht-fr">
                    Ministère de l'Enseignement Supérieur et de la Recherche
                    Scientifique
                  </div>
                </div>
                <div className="doc-heading-line"></div>
                <div className="doc-heading-bottom">
                  <div className="doc-hb-left">
                    <span className="doc-hb-uplef-text">EPST/CDER</span>
                    <span className="doc-hb-bottlef-text">
                      UNITE DE DEVELOPEMENT DES EQUIPEMENTS SOLAIRES
                    </span>
                  </div>
                  <div className="doc-heading-logo">
                    <img src={logo} alt="logo" />
                  </div>

                  <div className="doc-hb-right">
                    <span className="doc-hb-upright-text">
                      م.ع.ط.ع.ت./م.ط.ت.م
                    </span>
                    <span className="doc-hb-bottright-text">
                      وحدة تنمية الاجهزة الشمسية
                    </span>
                  </div>
                </div>
                <div className="doc-heading-line"></div>
              </div>

              <div className="doc-body-top">
                <div className="doc-top-info">
                  <span className="label">N°:</span>
                  <span className="value">{selectedForm.intern_req_ref}</span>
                </div>
                <div className="doc-top-info">
                  <span className="label">Date:</span>
                  <span className="value">
                    {new Date(selectedForm.intern_req_date).toLocaleDateString(
                      "en-GB"
                    )}
                  </span>
                </div>
              </div>

              <div className="info">
                <span className="" htmlFor="req_name">
                  Nom et prénom:
                </span>
                <span id="req_name" className="value" value="value">
                  {selectedForm.visit_name}
                </span>
              </div>
              <div className="info">
                <span className="" htmlFor="req_birthday">
                  Numero de telephone:
                </span>
                <span id="req_birthay" className="value">
                  {selectedForm.visit_phone}
                </span>
              </div>

              <div className="info">
                <span for="email" className="" htmlFor="intern_email">
                  Email:
                </span>
                <span id="intern_email" className="value">
                  {selectedForm.visit_email}
                </span>
              </div>
              <div className="info">
                <span className="" htmlFor="req_school">
                  Ecole/Etablissement:
                </span>
                <span id="req_school" className="value">
                  {selectedForm.visit_organization}
                </span>
              </div>
              <div className="info">
                <span className="" htmlFor="req_school_level">
                  Nombre de visiteurs:
                </span>
                <span id="req_school_level" className="value">
                  {selectedForm.visit_number}
                </span>
              </div>
              <div className="info">
                <span className="" htmlFor="req_speciality">
                  Objet de la visite:
                </span>
                <span id="req_speciality" className="value">
                  {selectedForm.visit_purpose}
                </span>
              </div>
              <div className="info">
                <span className="" htmlFor="req_option">
                  Date de visite souhaitée:
                </span>
                <span id="req_option" className="value">
                  du: {selectedForm.visit_start_date}
                </span>
                <span id="req_option" className="value">
                  au: {selectedForm.visit_end_date}
                </span>
              </div>

              <div className="doc-body-bottom">
                <div id="doc-approvers" className="doc-approvers"></div>
              </div>

              <div className="doc-footer">
                <div className="doc-footer-separator"></div>
                <span className="doc-footer-text">
                  UDES, Route Nationale N°11, BP386, Bou-Ismail, 42415, Wilaya
                  de Tipaza Tel. / Fax : 024221408, Site Web :udes.cder.dz
                </span>
              </div>
            </div>
          </div>
        </div>
        <div className="navBarControls_req_treatment">
          <div className="printing-menu">
            <span>Imprimer le document</span>
            <ReactToPrint
              content={reactToPrintContent}
              documentTitle="AwesomeFileName"
              removeAfterPrint
              trigger={reactToPrintTrigger}
            />
          </div>
          <div className="printing-menu">
            <Button
              id="btn-delete-app-req"
              onClick={confirm2}
              icon="pi pi-times"
              label="Supprimer la demande de visite!"
              className="bg-orange-500 hover:bg-red-500 disabled:ml-auto disabled:mr-auto   text-white font-bold py-2 px-4 rounded"
            ></Button>
          </div>
        </div>

        <Toast ref={toast} />

        <div className="p-confirm-dialog	">
          <ConfirmDialog className="p-confirm-dialog" />
        </div>
      </div>

      {/* <footer className="main-footer">
        <div className="">
          <div className="">
            <div className="">
              <h5>About</h5>
              <p>This is the footer with some text.</p>
            </div>
          </div>
        </div>
      </footer> */}
    </Fragment>
  );
};
